import { useEffect, useState } from "react";
import useTotp from "../Service/hooks/useTOTP";
import TOTPSetup from "./TOTPSetup";
import useAuthentication from "../Service/hooks/useAuthentication";
export default function SecondFactorForm({ setupRequired }) {

    const { error, errorMessage, checkTotpCode,checkRememberedTOTP, tokenEmailSend, sendTokenEmail, hasRememberedTOTP, sendTokenEmailManually } = useTotp();
    const { communicationMethod } = useAuthentication();


    useEffect(() => {
        checkRememberedTOTP();        
    }, [])

    const submitSecondFactor = (e) => {
        e.preventDefault();
        const data = new FormData(e.target);
        checkTotpCode({ code: data.get('code'), remember: data.get('remember') == "on" });
    }
    
    useEffect(() => {
        (async () => {
            let hasRememberedTOTPBool = await hasRememberedTOTP();
            if(communicationMethod === 'email' && !setupRequired && !hasRememberedTOTPBool) {
                sendTokenEmail();
            }
        })();
    }, [communicationMethod])

    if(setupRequired) {
        return <TOTPSetup />
    }




    return <form onSubmit={submitSecondFactor} className="flex flex-col gap-3">

        {/* { error && <div className="bg-red-500 text-white p-2"> {error} </div> } */}
        

        <label>
            {communicationMethod === 'email' && <p className="text-lg mt-0 pt-0">Om de veiligheid te verhogen, sturen we een 2FA code naar uw e-mailadres. Vul deze hieronder in.</p>}
            {communicationMethod !== 'email' && <p className="text-lg mt-0 pt-0">Om de veiligheid te verhogen, open de authenticator app. Vul de code van zorgconnect hieronder in.</p>}
            { errorMessage && <div className="bg-red-500 text-white p-2"> {errorMessage} </div> }
            <p className="text-lg pt-2">2FA Code:</p>
            <input name="code" autoComplete="off" className="w-full border border-gray-300 p-2" />
        </label>
       
        <label className="flex flex-row gap-2">
            <input name="remember" type="checkbox" />
            <p className="text-lg">
                Onthoud dit apparaat/netwerk
            </p>
        </label>
        <button type="submit" className="w-full bg-[#3A194A] text-white p-2 font-bold">Inloggen afronden</button>
        {communicationMethod === 'email' && <SendTokenEmailButton />} 
    </form>

}

function SendTokenEmailButton() {
    const { communicationMethod } = useAuthentication();
    const { sendTokenEmailManually } = useTotp();

    const [isSent, setIsSent] = useState(false);
    const [loading, setLoading] = useState(false);


    const resendTokenEmail = async () => {
        setLoading(true);
        await sendTokenEmailManually();
        setLoading(false);
        setIsSent(true);
    }

    useEffect(() => {
        if(isSent) {
            let timeout = setTimeout(() => {
                setIsSent(false);
            }, 30000);
            return () => clearTimeout(timeout); 
        }
    }, [isSent]);

    return <button disabled={loading || isSent} onClick={resendTokenEmail} 
        className="w-full bg-[#3A194A] text-white p-2 font-bold disabled:opacity-50">
        {isSent ? 'Verstuurd!' : 'Verstuur 2FA code opnieuw'}
    </button>


}